import { useState } from 'react';
import { toast } from 'sonner';
import { logError } from '../utils/logger';

const FALLBACK_PHONE = '252-564-5612';
const TOAST_DISPLAY_MS = 6000;

const postLead = (endpoint, payload) =>
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

const showErrorToast = (message) =>
  toast.error('Submission failed', { description: message, duration: TOAST_DISPLAY_MS });

// Shared lead-submission hook: posts to /api{endpoint}, flags `submitted` for
// `resetMs`, then runs `onSuccess`. Failures show a toast with a call fallback
// unless `treatErrorAsSuccess` is set.
export function useLeadSubmit({ endpoint, onSuccess, errorLabel = 'lead', errorMessage, resetMs = 3000, treatErrorAsSuccess = false }) {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const flagSuccess = (payload) => {
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      if (onSuccess) onSuccess(payload);
    }, resetMs);
  };

  const handleFailure = (payload, detail) => {
    logError(`Error submitting ${errorLabel}:`, detail);
    if (treatErrorAsSuccess) flagSuccess(payload);
    else showErrorToast(errorMessage || `We couldn't send your ${errorLabel}. Please call or text Jess at ${FALLBACK_PHONE}.`);
    return false;
  };

  const submit = async (payload) => {
    setSubmitting(true);
    try {
      const response = await postLead(endpoint, payload);
      if (!response.ok) return handleFailure(payload, `HTTP ${response.status}`);
      flagSuccess(payload);
      return true;
    } catch (error) {
      return handleFailure(payload, error);
    } finally {
      setSubmitting(false);
    }
  };

  return { submitted, submitting, submit, setSubmitted };
}
